import React from "react";
import clsx from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  allowDecimal?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: boolean;
  imageName?: string;
  startIcon?: any;
  forceDecimal?: boolean;
  negativeOnly?: boolean;
  negativeLabel?: boolean;
  iconOnClick?: () => void;
}

const onForceDecimal = (e: any) => {
  return (e.target.value = e.target.valueAsNumber.toFixed(2));
};

// FIXME: remove w-full
const BASE_STYLES =
  "border border-input-border font-medium rounded-xl text-text-primary outline-none bg-input-bg text-[14px] py-[10px] px-3.5 w-full h-11 transition-all duration-200 focus:border-indigo-400/50 focus:ring-2 focus:ring-indigo-400/20 placeholder:text-placeholder disabled:opacity-60 disabled:cursor-not-allowed";

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      disabled,
      helperText,
      className,
      allowDecimal,
      dataTestId,
      icon,
      imageName,
      startIcon,
      forceDecimal,
      negativeOnly,
      negativeLabel,
      iconOnClick,
      ...props
    }: InputProps,
    ref
  ) => {
    const allowStep = allowDecimal && props.type === "number";

    return (
      <div className="space-y-1.5 w-full">
        {label ? (
          <label
            className="text-light-gray font-medium block text-[13px] leading-tight"
            data-testid="input-label"
            htmlFor={id}
          >
            {label}
          </label>
        ) : null}
        <div className="relative">
          {startIcon ? (
            <p className="h-full px-2 absolute left-1 top-[11px] text-light-gray font-medium text-[14px]">
              {startIcon}
            </p>
          ) : null}
          {negativeLabel ? (
            <p className="h-full px-2 absolute left-5 top-[11px] text-light-gray font-medium text-[14px]">
              -
            </p>
          ) : null}
          <input
            {...props}
            data-testid={dataTestId}
            aria-invalid={!!error}
            disabled={disabled}
            aria-disabled={disabled}
            id={id}
            step={allowStep ? "0.01" : undefined}
            ref={ref}
            onBlur={forceDecimal ? onForceDecimal : null}
            onInput={
              negativeOnly
                ? (e: any) => (e.target.value = -Math.abs(e.target.value))
                : null
            }
            className={clsx(
              BASE_STYLES,

              className,
              error && "border-ilara-red ring-1 ring-red-400/40",
              startIcon && "pl-8",
              startIcon && negativeLabel && "!pl-10"
            )}
          />
        </div>
        {icon ? (
          <img
            src={imageName}
            className="w-4 h-4 absolute top-0 !mt-8 mr-8 flex justify-center items-center right-0 cursor-pointer"
            alt=""
            onClick={iconOnClick}
          />
        ) : null}
        {error || helperText ? (
          <p
            className={`${
              error ? "text-red-500" : "text-ilara-secondary-text"
            } text-xs font-medium`}
            data-testid={error ? "input-error" : "input-helper-text"}
          >
            {error || helperText}
          </p>
        ) : null}
      </div>
    );
  }
);

export default CustomInput;
